import { Button } from '@trussworks/react-uswds';
import DeleteButton from './DeleteButton';
import { useModal } from '@stores';

// deprecated?
const ModalFooter = ({
  cancelText = 'Cancel',
  customClosingLogic = false,
  deleteText = 'Delete',
  onCancel = null,
  onDelete = null,
  onSave = null,
  saveIsDisabled = false,
  saveIsSubmit = false,
  saveText = 'Save',
  showCancelButton = false,
  showSaveButton = true,
}) => {
  const { closeSecondaryModal } = useModal();
  const saveButtonProps = {
    disabled: saveIsDisabled,
    children: saveText,
    ...(saveIsSubmit
      ? {
          type: 'submit',
        }
      : {
          onClick: (e) => {
            if (onSave) onSave(e);
            if (!customClosingLogic) closeSecondaryModal();
          },
        }),
  };

  return (
    <footer className='primary-modal-footer'>
      {(showCancelButton || onCancel) && (
        <Button
          variant='secondary'
          text={cancelText}
          base
          onClick={(e) => {
            if (onCancel) onCancel(e);
            closeSecondaryModal();
          }}
        >
          {cancelText}
        </Button>
      )}
      {onDelete && (
        <DeleteButton deleteText={deleteText} handleDelete={onDelete} customClosingLogic={customClosingLogic} />
      )}
      {showSaveButton && <Button {...saveButtonProps} />}
    </footer>
  );
};

export default ModalFooter;
